import Joi from '@hapi/joi'

export const EmployeeBiometricSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Select Operatin Entity`,
        "any.required": `Operatin Entity required`
    }),
    registrationNumber: Joi.string().allow(null, "").alphanum().max(20).label("Registration Number").messages({
        
        "string.pattern.base": `Please enter valid Registration Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    NIC: Joi.string().allow(null, "").alphanum().max(50).label("NIC").messages({
        
        "string.pattern.base": `Please enter valid NIC`,
        "string.max": `Please enter {#limit} characters.`
    }),
}

export const EmployeeListingSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Select Operatin Entity`,
        "any.required": `Operatin Entity required`
    }),
    employeeCode: Joi.string().max(20).required().regex(/^(?!\s*$).+/).label("Employee Code").messages({
        "string.pattern.base": `Please enter valid Employee Code`,
        "string.max": `Please enter {#limit} characters.`
    }),
    NIC: Joi.string().max(50).required().regex(/^(?!\s*$).+/).label("NIC").messages({
        "string.pattern.base": `Please enter valid NIC`,
        "string.max": `Please enter {#limit} characters.`
    }),
}

export const EmployeeSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Select Operatin Entity`,
        "any.required": `Operatin Entity required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Collectionpoint").messages({
        "any.invalid": `Select Collectionpoint.`,
        "any.required": `Collectionpoint required`
    }),    
    employeeTypeID: Joi.number().invalid(0).required().label("Employee Category").messages({
        "any.invalid": `Select Employee Category.`,
        "any.required": `Employee Category required`
    }),
    employeeCategoryID: Joi.number().invalid(0).required().label("Employee Type").messages({
        "any.invalid": `Select Employee Type.`,
        "any.required": `Employee Type required`
    }),
    employeeCode: Joi.string().alphanum().max(20).required().label("Employee Code").messages({
        "string.empty": `Employee Code required`,
        "string.pattern.base": `Please enter valid Employee Code`,
        "string.max": `Please enter {#limit} characters.`
    }),
    title: Joi.number().invalid(0).required().required().label("Title").messages({
        "string.empty": `Title required`,
        "string.pattern.base": `Please enter valid Title`,
        "string.max": `Please enter {#limit} characters.`
    }),
    firstName: Joi.string().max(100).required().label("First Name").messages({
        "string.empty": `First Name required`,
        "string.pattern.base": `Please enter valid First Name`,
        "string.max": `Please enter {#limit} characters.`
    }),
    secondName: Joi.string().max(100).allow("", null).label("Second Name").messages({
        "string.empty": `Second Name required`,
        "string.pattern.base": `Please enter valid Second Name`,
        "string.max": `Please enter {#limit} characters.`
    }),
    lastName: Joi.string().max(100).required().label("Last Name").messages({
        "string.empty": `Last Name required`,
        "string.pattern.base": `Please enter valid Last Name`,
        "string.max": `Please enter {#limit} characters.`
    }),
    gender: Joi.number().invalid(0).required().label("Gender").messages({
        "string.empty": `Gender required`,
        "string.pattern.base": `Please enter valid Gender`,
        "string.max": `Please enter {#limit} characters.`
    }),
    nic: Joi.string().alphanum().max(50).required().label("NIC").messages({
        "string.empty": `NIC required`,
        "string.pattern.base": `Please enter valid NIC`,
        "string.max": `Please enter {#limit} characters.`
    }),
    address1:  Joi.string().max(100).allow("", null).label("Address1").messages({
        "string.empty": `Address required`,
        "string.pattern.base": `Please enter valid Address`,
        "string.max": `Please enter {#limit} characters.`
    }),
    address2:  Joi.string().max(100).allow("", null).label("Address2").messages({
        "string.empty": `Address required`,
        "string.pattern.base": `Please enter valid Address`,
        "string.max": `Please enter {#limit} characters.`
    }),
    address3:  Joi.string().max(100).allow("", null).label("Address3").messages({
        "string.empty": `Address required`,
        "string.pattern.base": `Please enter valid Address`,
        "string.max": `Please enter {#limit} characters.`
    }),
    city: Joi.string().alphanum().max(50).allow("", null).label("City").messages({
        "string.empty": `City required`,
        "string.pattern.base": `Please enter valid City`,
        "string.max": `Please enter {#limit} characters.`
    }),
    countryCode: Joi.number().invalid(0).required().label("Country").messages({
        "string.empty": `Country required`,
        "string.pattern.base": `Please enter valid Country`,
        "string.max": `Please enter {#limit} characters.`
    }),
    homePhoneNo: Joi.number().allow("", null).label("Home Phone Number").messages({
        "string.empty": `Home Phone Number required`,
        "string.pattern.base": `Please enter valid Home Phone Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    officePhoneNo: Joi.number().allow("", null).label("Office Phone Number").messages({
        "string.empty": `Office Phone Number required`,
        "string.pattern.base": `Please enter valid Home Office Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    dateOfBirth: Joi.string().isoDate().required().label("Date of birth"),
    mobileNo: Joi.number().allow("", null).label("Mobile Number").messages({
        "string.empty": `Mobile Number required`,
        "string.pattern.base": `Please enter valid Mobile Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    email:  Joi.string().allow("", null).label("Email").regex(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/).messages({
        "string.pattern.base": `"Invalid Email`,
        "string.empty": `Email Required`,
    }),
    question: Joi.string().max(25).allow("", null).label("Question").messages({
        "string.empty": `Question required`,
        "string.pattern.base": `Please enter valid Question`,
        "string.max": `Please enter {#limit} characters.`
    }),
    answer: Joi.string().max(25).allow("", null).label("Answer").messages({
        "string.empty": `Answer required`,
        "string.pattern.base": `Please enter valid Answer`,
        "string.max": `Please enter {#limit} characters.`
    }),
    registrationNumber:  Joi.string().alphanum().max(10).required().label("Registration Number").messages({
        "string.empty": `Registration Number required`,
        "string.pattern.base": `Please enter valid Registration Number`,
        "string.max": `Please enter {#limit} characters.`
    }),
    nameToBePrinted:  Joi.string().max(20).required().label("Name To Be Printed").messages({
        "string.empty": `Name To Be Printed required`,
        "string.pattern.base": `Please enter valid Name To Be Printed`,
        "string.max": `Please enter {#limit} characters.`
    }),
    isSupplementary: Joi.boolean().label("Active"),
    employeeSubCategoryID:  Joi.string().allow("", null),
    designationID:Joi.number().invalid(0).required().label("Employee Designation").messages({
        "any.invalid": `Select Employee Designation.`,
        "any.required": `Employee Designation required`
    }),
    maritalStatusID:Joi.string().allow("", null),
    raceID: Joi.string().allow("", null),
    religionID: Joi.string().allow("", null),
    fieldID:Joi.number().required().label("Feild").messages({
        "any.invalid": `Select Feild Name.`,
        "any.required": `Feild name required`
    }),
    description: Joi.string().allow("", null)
}